import {
  BaseReport,
  darkerLightFirstColumnColor,
  darkerLightFourthColumnColor,
  darkerLightSecondColumnColor,
  darkerLightThirdColumnColor,
  generalTitleColor,
  lightFirstColumnColor,
  lightFourthColumnColor,
  lightSecondColumnColor,
  lightThirdColumnColor,
} from './BaseReport';
// PDF
// @ts-ignore
import htmlToPdfmake from 'html-to-pdfmake';
// lodash
import { fill, groupBy, orderBy, uniqBy } from 'lodash';
// Interfaces
import { ISchool } from '../interfaces/commons/ISchool';
import { IUsers } from '../interfaces/commons/IUsers';
import moment from "moment";
import _ from "lodash";

const lightColorArray: string[] = [
  generalTitleColor,
  lightFirstColumnColor,
  lightSecondColumnColor,
  lightThirdColumnColor,
  lightFourthColumnColor,
];

const darkerLightColorArray: string[] = [
  generalTitleColor,
  darkerLightFirstColumnColor,
  darkerLightSecondColumnColor,
  darkerLightThirdColumnColor,
  darkerLightFourthColumnColor,
];

/* tslint:disable:curly */
/* tslint:disable:no-console */

class PlanningReport extends BaseReport {

  constructor(user: IUsers, school: ISchool, dataToReport: any, logoURL: string) {
    super(user, school, dataToReport, logoURL);
  }

  public blueDot(x: number) {
    return {
      canvas: [
        {
          type: 'ellipse',
          x, y: 4,
          color: '#7B2A7E',
          r1: 2.5, r2: 2.5,
        },
      ],
    };
  }

  public async downloadReport(): Promise<any> {
    if (this.testing) {
      // const reportPlan = {
      //   content: data.data.flatMap((unitPlan: any, index: number) =>
      //     this.buildPlanReport(unitPlan, index, data.data.length),
      //   ),
      // };
      //
      // return await this.generateReport(reportPlan, {
      //   reportTitle: 'PLANIFICACIÓN - ' + this.school.yearSelected,
      //   firstTitle: data.category + (!!data.course ? (' ' + data.course) : ''),
      //   secondTitle: data.subject,
      //   reportType: data.reportType,
      //   emissionDate: data.emissionDate,
      // });
    } else {
      if (
        !this.dataToReport ||
        !Array.isArray(this.dataToReport.data) ||
        this.dataToReport.data.length <= 0
      ) {
        console.error('NO SE GENERÓ REPORTE', this.dataToReport);
        if (
          Array.isArray(this.dataToReport.data) &&
          this.dataToReport.data.length <= 0
        ) {
          alert('No hay datos para generar reporte');
        } else {
          alert('Reporte no pudo ser generado');
        }
        window.location.href = '/organizer';
        return;
      }

      const reportPlan = {
        content: this.dataToReport.data.flatMap((unitPlan: any, index: number) =>
          this.buildPlanReport(unitPlan, index, this.dataToReport.data.length)),
      };

      return await this.generateReport(reportPlan, {
        reportTitle: 'PLANIFICACIÓN - ' + this.school.yearSelected,
        firstTitle: this.dataToReport.category + (!!this.dataToReport.course ? (' ' + this.dataToReport.course) : ''),
        secondTitle: this.dataToReport.subject,
        reportType: this.dataToReport.reportType,
        emissionDate: this.dataToReport.emissionDate,
        pageOrientation: 'landScape'
      });
    }
  }

  public buildPlanReport(unitPlan: any, index: number, unitPlansCount: number): any[] {
    const changeHeaderAndFooter: string = JSON.stringify({
      footer: unitPlan.id,
    });
    if(unitPlan.activities){
      const activitiesWithOrder = unitPlan.activities.filter((activity) => activity.order != 0);
      const activitiesWithoutOrder = unitPlan.activities.filter((activity) => activity.order == 0);
      unitPlan.activities = [
          ... _.orderBy(activitiesWithOrder, ['order', 'id'], ['asc', 'asc']),
          ... _.orderBy(activitiesWithoutOrder, 'id', 'asc'),
      ]
    }
    const purposeSection: any[] = this.buildPurpose(unitPlan);
    const planificationSection: any[] = this.buildActivities(unitPlan);
    const cronogramSection: any[] = this.buildCronogram(unitPlan);

    //This will only page break after page 1 in function BaseReport.pageBreakBefore
    const customPageBreak: any[] = [{
      text: 'pageBreak',
      fontSize: 1,
      color: '#FFFFFF',
      style: ['pageBreak', 'startUnitPlan'],
    }];
    const pageBreak: any[] = [{ text: '', pageBreak: 'after' }];
    
    return customPageBreak.concat(
      purposeSection,
      purposeSection.length > 0 &&
        (planificationSection.length > 0 || cronogramSection.length > 0)
        ? pageBreak
        : [],
      planificationSection,
      planificationSection.length > 0 && (cronogramSection.length > 0)
        ? pageBreak
        : [],
      cronogramSection,
      [
        {
          text: '0',
          color: 'white',
          fontSize: 1,
          changeHeaderAndFooter,
          margin: 0,
        },
      ],
    );
  }

  public buildPurpose(unitPlan: any, paginateBefore: boolean = false): any[] {
    if (!unitPlan.purpose) return [];
    const uniqueEjes: any[] = uniqBy(unitPlan.objectives, 'oa.cod_eje').map((puOA: any) => {
      return {
        text: [{ text: puOA.oa.cod_eje + ' ', bold: true }, puOA.oa.eje],
        alignment: 'left',
        margin: [0, 0, 0, 3],
      };
    });
    return [
      {
        text: unitPlan.purpose.proposito,
        style: ['parrafo2'],
        margin: [0, 0, 0, 10]
      },
      {
        ...this.generalTable({
          tableContent: {
            widths: ['*', '*', '*'],
            keepWithHeaderRows: 0,
            body: [
              this.generateColoredRows([
                'Aprendizaje Previo',
                'Habilidades de Asignatura',
                'Actitudes',
              ]),
              [
                {
                  ul: unitPlan.purpose.selectedIdConocimientosPrevios.map(
                    (puc: any) => {
                      return {
                        text: puc.nombre,
                        alignment: 'left',
                        style: ['parrafo2'],
                        margin: [0, 0, 0, 3],
                      };
                    },
                  ),
                },
                {
                  ul: unitPlan.purpose.selectedIdAprendizajeNiveles.map(
                    (an: any) => {
                      return {
                        text: [
                          { text: an.codigo + ' ', bold: true, style: ['parrafo2'], },
                          an.nombre,
                        ],
                        style: ['parrafo2'],
                        alignment: 'left',
                        margin: [0, 0, 0, 3],
                      };
                    },
                  ),
                },
                {
                  ul: unitPlan.purpose.selectedIdActitudes.map((a: any) => {
                    return {
                      text: [{ text: a.codigo + ' ', bold: true, style: ['parrafo2'], }, a.nombre],
                      alignment: 'left',
                      style: ['parrafo2'],
                      margin: [0, 0, 0, 3],
                    };
                  }),
                },
              ],
            ],
          },
          layout: {
            fillColor: (rowIndex: number, node: any, columnIndex: number) =>
              this.fillColorByIndex(rowIndex, node, columnIndex),
          },
        }),
      },
      {
        ...this.generalTable({
          tableContent: {
            widths: ['33.3%', '*'],
            keepWithHeaderRows: 0,
            body: [
              this.generateColoredRows(['Ejes', 'Organización de la unidad']),
              [
                {
                  type: 'none',
                  ul: uniqueEjes,
                },
                {
                  ...this.generalTable({
                    tableContent: {
                      widths: ['*', 40, 70],
                      body: this.buildObjectivesRows(unitPlan.objectives),
                    },
                    layout: {
                      hLineWidth: (i: number, node: any) =>
                        i !== 0 && i !== node.table.body.length ? 0.1 : 0.1,
                      vLineWidth: (i: number, node: any) =>
                        i !== 0 && i !== node.table.widths.length ? 0.1 : 0.1,
                    },
                    otherProperties: {
                      margin: [0, 0, 0, 0],
                    },
                  }),
                },
              ],
            ],
          },
          layout: {
            fillColor: (rowIndex: number, node: any, columnIndex: number) =>
              this.fillColorByIndex(rowIndex, node, columnIndex),
            paddingLeft: () => 0,
            paddingRight: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0,
          },
          otherProperties: {
            margin: [0, 0, 0, 0],
          },
        }),
      },
      {
        alignment: 'right',
        text: '* Oas transversales de la unidad',
        fontSize: 8,
        margin: [0, 0, 0, 10],
      },
    ];
  }

  public buildActivities(unitPlan: any): any[] {
    if (!unitPlan.activities) return [];
    return [
      this.generalTable({
        tableContent: {
          widths: ['10%', '30%', '17%', '*', '20%'],
          keepWithHeaderRows: 0,
          body: [
            this.generateColoredRows([
              'Fecha',
              'Objetivos de Aprendizaje',
              'Principios DUA',
              'Actividades',
              'Evaluación',
            ], false),
            ...this.buildActivitiesRows(unitPlan),
          ],
        },
        id: 'activity',
        layout: {
          fillColor: (rowIndex: number, node: any, columnIndex: number) =>
            this.fillColorByIndex(rowIndex, node, columnIndex, false),
          hLineWidth: (i: number, node: any) =>
            i !== 0 && i !== node.table.body.length ? 0.1 : 0.1,
          vLineWidth: (i: number, node: any) =>
            i !== 0 && i !== node.table.body.length + 1 ? 0.1 : 0.1,
        },
      }),
    ];
  }

  public buildActivitiesRows(unitPlan: any): any[] {
    unitPlan.activities = orderBy(unitPlan.activities, ['semanaClase.fechaInicio', 'id']);
    return unitPlan.activities.map((activity: any) => {
      const orderedObjectives: any[] = orderBy(
        Object.entries(groupBy(activity.selectedIes, (ie: any) => ie.oa_id))
          .map((entry: any) => {
            // tslint:disable-next-line:radix
            entry[0] = Number.parseInt(entry[0]);
            entry[1] = entry[1].map((ie: any) => ie.id);
            const puOA = unitPlan.objectives.find(
              // tslint:disable-next-line:no-shadowed-variable
              (puOA: any) => puOA.oa_id === entry[0],
            );
            if (!puOA) return null;
            puOA.oa.ies = puOA.oa.ies.filter((ie: any) => entry[1].includes(ie.id));
            // puOA.oa.ies = orderBy(
            //   puOA.oa.ies.filter((ie: any) => entry[1].includes(ie.id)),
            //   ['cod']
            // );
            return puOA;
          })
          .filter((puOA: any) => !!puOA),
        ['oa.cod'],
      );

      return [
        {
          stack: [
            {
              text: this.getDateActivity(activity),
              margin: [0, 0, 0, 0],
              style: ['parrafo2'],
              alignment: "center"
            }
          ],
        },
        {
          stack: orderedObjectives.map((puOA: any) => {
            return {
              stack: [
                {
                  text: [
                    {
                      text: puOA.oa.cod_eje + ' - ' + puOA.oa.cod ,
                      style: ['parrafo2'],
                      bold: true,
                    },
                    puOA.oa.categoria != this.dataToReport.categoryAbrev ? '| ' + puOA.oa.categoria : ''
                    //puOA.oa.name + ' (' + puOA.hours + ' HORAS)',
                  ],
                  style: ['parrafo2'],
                  margin: [0, 0, 3, 10],
                  alignment: 'justify',
                },
                {
                  type: 'none',
                  ul: puOA.oa.ies.map((ie: any) => {
                    return {
                      text: [{ text: ie.cod + ' - ', style: ['parrafo2'], bold: true }, ie.name],
                      style: ['parrafo2'],
                      margin: [0, 0, 3, 5],
                      alignment: 'justify',
                    };
                  }),
                },
              ],
            };
          }),
        },
        {
          text: orderBy(
            activity.selectedDuas.flatMap((category: any) => category.duas),
            ['code'],
          ).map((dua: any) => {
            return {
              text: [
                { text: dua.code + ' ', bold: true , style: ['parrafo2'],},
                { text: dua.name.toUpperCase() + '\n\n', style: ['parrafo2'], }
              ],
            };
          }),
          style: ['parrafo2'],
          alignment: 'justify',
        },
        {
          stack: this.renderMomentos(activity),
        },
        {
          stack: this.renderEvaluaciones(activity),
        },
      ];
    });
  }

  public getDateActivity(date) {
    if (date.semanaClase) {
      const initDate = moment(String(date.semanaClase.fechaInicio), 'YYYY-MM-DD').format("DD/MM");
      const endDate = moment(String(date.semanaClase.fechafin), 'YYYY-MM-DD').format("DD/MM");
      return initDate + `${initDate != endDate ? ' - ' + endDate : ''}`;
    } else if (date.fechaClase != 'null' && date.fechaClase != null) {
      return moment(String(date.fechaClase)).format("DD/MM");
    } else if (date.mesClase != 'null' && date.mesClase != null) {
      return date.mesClase;
    } else {
      return 'No disponible';
    }
  }

  public renderMomentos(activity) {
    let datos = [];
    datos.push({
      text: activity.titulo,
      margin: [0, 0, 20, 0],
      style: ['parrafo2'],
      bold: true
    });
    if (activity.semanaClase || (activity.mesClase != 'null' && activity.mesClase != null)) {
      datos = [...datos, ...htmlToPdfmake( this.styleAndTransformImages(activity.momentos[0].actividadMomento, 170))];
      if (activity.momentos[0].fileList.length > 0) {
        datos.push({
          text: 'Archivos:',
          margin: [0, 0, 20, 0],
          style: ['parrafo2'],
          bold: true
        });
        activity.momentos[0].fileList.forEach(file => {
          datos.push({
            text: file.name,
            style: ['parrafo2'],
            margin: [0, 0, 20, 0]
          });
        });
      }
    } else {
      _.sortBy(activity.momentos, 'id', 'asc').forEach((mo, index) => {
        datos.push({
          text: mo.titulo ? mo.titulo : '',
          margin: [0, 0, 20, 0],
          style: ['parrafo2'],
          bold: true
        });
        datos = [...datos, ...htmlToPdfmake(this.styleAndTransformImages(mo.actividadMomento, 170))];
        if (mo.fileList.length > 0) {
          datos.push({
            text: 'Archivos:',
            margin: [5, 0, 20, 0],
            style: ['parrafo2'],
            bold: true
          });
          mo.fileList.forEach(file => {
            datos.push({
              text: file.name,
              style: ['parrafo2'],
              margin: [5, 0, 20, 0]
            });
          });
          datos.push({
            text: ' ',
            margin: [5, 0, 20, 0],
            style: ['parrafo2'],
            bold: true
          });
        }

      });
    }
    return datos;
  }

  public renderEvaluaciones(activity) {
    let datos = [];
    _.sortBy(activity.momentos, 'id', 'asc').forEach(mo => {

      if (activity.fechaClase != 'null' && activity.fechaClase != null && mo.evaluaciones.length) {
        datos.push({
          text: mo.titulo,
          margin: [0, 0, 20, 0],
          style: ['parrafo2'],
          bold: true
        });
      }

      mo.evaluaciones.forEach(eva => {
        datos.push({
          text: "Evaluación:",
          margin: [5, 0, 20, 0],
          style: ['parrafo2'],
          bold: true
        });
        datos = [...datos, ...htmlToPdfmake(this.styleAndTransformImages(eva.actividadEvaluacion, 150))];
        datos.push({
          text: eva.tipoEvaluacion.nombre + ' - ' + eva.tipoInstrumentoEvaluacion.nombre,
          margin: [5, 0, 20, 0]
        });
        if (eva.fileList.length > 0) {
          datos.push({
            text: 'Archivos:',
            margin: [5, 0, 20, 0],
            style: ['parrafo2'],
            bold: true
          });
          eva.fileList.forEach(file => {
            datos.push({
              text: file.name,
              margin: [5, 0, 20, 0],
              style: ['parrafo2'],
            });
          });
          datos.push({
            text: ' ',
            margin: [5, 0, 20, 0],
            style: ['parrafo2'],
            bold: true
          });
        }
      });
    });
    return datos;
  }
  public buildCronogram(unitPlan: any): any[] {
    if (!unitPlan.cronogram) return [];
    let addToTitle: string = '\nNo hay cronograma para la unidad';
    let addToTitle2: string = '\nNo hay cronograma para la unidad';

    if (unitPlan.cronogram.length > 0) {
      const firstWeek: any = unitPlan.cronogram[0].semanas[0];
      const lastWeek: any = unitPlan.cronogram[unitPlan.cronogram.length - 1]
        .semanas[unitPlan.cronogram[unitPlan.cronogram.length - 1].semanas.length - 1];

      const iniDate: string = firstWeek.iniDia + '/' + firstWeek.iniMes + '/' + firstWeek.iniAño;
      const finDate: string = lastWeek.finDia + '/' + lastWeek.finMes + '/' + lastWeek.finAño;

      // @ts-ignore
      addToTitle = {
        text: '\nPLANIFICACIÓN del ' + iniDate + ' al ' + finDate,
        style: ['titulo5'],
      };
      // @ts-ignore
      addToTitle2 = {
        text: '\nPLANIFICACIÓN del ' + iniDate + ' al ' + finDate,
        style: ['titulo5'],
      };
    }

    const items: any[] = unitPlan.cronogram.flatMap((month: any) => month.semanas)
      .flatMap((week: any) => week.planUnidadSemanaItemToList);

    const uniquePlannedOAsIds: number[] =
      // @ts-ignore
      items.map((item: any) => item.idPlanUnidadOA)

    const uniquePlannedIEsIds: number[] =
      // @ts-ignore
      items.map((item: any) => item.ie_id)

    const OAsPlanned: any[] = unitPlan.objectives
      .filter((puOA: any) => uniquePlannedOAsIds.includes(puOA.id))
      .map((puOA: any) => {
        puOA.oa.ies = puOA.oa.ies.filter((ie: any) => uniquePlannedIEsIds.includes(ie.id));
        return puOA;
      });

    const pageBreak: any[] = [{ text: '', pageBreak: 'after' }];
    const leyend: any = {
      margin: [0, -15, 0, 0],
      layout: 'noBorders',
      table: {
        widths: [585, '*'],
        body: [[
          addToTitle,
          {
            columnGap: 0,
            alignment: 'right',
            margin: [0, 15, 0, 0],
            columns: [
              {
                text: 'OA/IE planificado (',
                style: ['parrafo2'],
                width: 'auto',
                alignment: 'left',
              },
              {
                alignment: 'left',
                width: 'auto',
                ...this.blueDot(2.5),
              },
              {
                text: ')',
                width: 'auto',
                style: ['parrafo2'],
                alignment: 'left',
              },
              {
                margin: [10, 0, 0, 0],
                text: 'Evaluación planificada (',
                width: 'auto',
                style: ['parrafo2'],
              },
              {
                text: 'EV',
                alignment: 'center',
                width: 'auto',
                style: ['parrafo2'],
              },
              {
                text: ')',
                width: 'auto',
                style: ['parrafo2'],
              },
            ],
          },
        ]]
      }
    }
    /*
    const leyend: any = {
      stack: [
        {
          columnGap: 0,
          columns: [
            {
              text: 'Asignación de OA o IE es representado por (',
              color: 'grey',
              fontSize: 10,
              alignment: 'left',
              width: 'auto',
            },
            {
              alignment: 'left',
              width: 'auto',
              ...this.blueDot(2.5),
            },
            {
              text: ')',
              color: 'grey',
              fontSize: 10,
              alignment: 'left',
              width: 'auto',
            },
          ],
        },
        {
          text: [
            {
              text: 'Asignación de evaluación es representado (',
              color: 'grey',
              fontSize: 10,
            },
            {
              text: 'EV',
              bold: true,
              alignment: 'center',
              fontSize: 10,
            },
            {
              text: ')',
              color: 'grey',
              fontSize: 10,
            },
          ],
        },
      ],
    };
    */

    const leyend1: any = {
      margin: [0, -15, 0, 0],
      layout: 'noBorders',
      table: {
        widths: [585, '*'],
        body: [[
          addToTitle2,
          {
            columnGap: 0,
            alignment: 'right',
            margin: [0, 15, 0, 0],
            columns: [
              {
                text: 'OA/IE planificado (',
                style: ['parrafo2'],
                width: 'auto',
                alignment: 'left',
              },
              {
                alignment: 'left',
                width: 'auto',
                ...this.blueDot(2.5),
              },
              {
                text: ')',
                width: 'auto',
                style: ['parrafo2'],
                alignment: 'left',
              },
              {
                margin: [10, 0, 0, 0],
                text: 'Evaluación planificada (',
                width: 'auto',
                style: ['parrafo2'],
              },
              {
                text: 'EV',
                alignment: 'center',
                width: 'auto',
                style: ['parrafo2'],
              },
              {
                text: ')',
                width: 'auto',
                style: ['parrafo2'],
              },
            ],
          },
        ]]
      }
    };

    return [
      leyend,
      ...this.buildCronogramTables(unitPlan.cronogram, OAsPlanned, false),
      pageBreak,
      leyend1,
      ...this.buildCronogramTables(unitPlan.cronogram, OAsPlanned, true),
      {
        text: 'Avance Total: ' + (unitPlan.TotalAdvance !== null ? unitPlan.TotalAdvance : '0') + '%',
        style: ['titulo5'],
        alignment: 'right',
      },
    ];
  }

  public buildCronogramTables(groupedCronogram: any[], objectives: any[], withDetails: boolean): any[] {
    return groupedCronogram.map((pairOfMonths: any) => {
      const dataForMonth = this.buildCronogramForMonth(pairOfMonths, withDetails);
      dataForMonth.weekDaysColumns[dataForMonth.weekDaysColumns.length - 1] = {
        ...dataForMonth.weekDaysColumns[dataForMonth.weekDaysColumns.length - 1],
        style: ['titulo6'],
        border: [true, false, true, true],
      };

      return this.generalTable({
        tableContent: {
          widths: ['*', 1].concat(
            pairOfMonths.semanas.map(() => 'auto'),
            withDetails ? [46] : [],
          ),
          headerRows: 2,
          keepWithHeaderRows: 0,
          body: [
            [
              this.generalTableHeader({
                headerContent: {
                  text: 'Objetivo / Indicador de Aprendizaje',
                  colSpan: 2,
                  rowSpan: 2,
                  fillColor: "#F8F8F8",
                  style: ['titulo6'],
                  margin: [0, 13, 0, 0],
                },
              }),
              '',
              ...dataForMonth.header,
            ].concat(withDetails ? [
              this.generalTableHeader({
                headerContent: {
                  text: ['%\n', 'Avance'],
                  rowSpan: 2,
                  fillColor: "#F8F8F8",
                  style: ['titulo6'],
                  border: [true, true, true, true],
                },
              }),
            ] : [],
            ),
            [
              {},
              {},
              ...dataForMonth.weekDaysColumns,
            ].concat(withDetails ? [{}] : []),
            ...objectives
              .map((puOA) => {
                const itemsOA: any[] = this.buildItemsForMonth(pairOfMonths, puOA);

                //if (itemsOA.every((item) => Object.entries(item).length === 0) || itemsOA.length === 0) return null;

                const OARow: any[] = [
                  {
                    text: [
                      { text: puOA.oa.cod, style: ['titulo6']},
                      { text: (puOA.oa.categoria != this.dataToReport.categoryAbrev ? ' | ' + puOA.oa.categoria : '') + ' - '+ puOA.oa.name, style: ['parrafo2'] }
                    ],
                    border: [true, false, false, true],
                  },
                  {
                    text: '',
                    alignment: 'center',
                    style: ['titulo6'],
                    margin: [0, 0, 0, 0],
                    border: [false, true, true, true],                    
                  },
                  ...itemsOA,
                ];

                if (withDetails) {
                  const IERows: any[] = puOA.oa.ies.map((ie: any) => {
                    const itemsIE: any[] = this.buildItemsForMonth(pairOfMonths, puOA, ie);
                    if (itemsIE.every((item) => Object.entries(item).length === 0) || itemsIE.length === 0) return null;

                    return [
                      {
                        text: [
                          { text: ie.cod + ' - ', style: ['parrafo2'], bold: true },
                          ie.name,
                        ],
                        style: ['parrafo2'],
                        border: [true, false, false, true],
                        margin: [10, 0, 0, 0],
                      },
                      {
                        text: '',
                        border: [false, true, true, true], 
                      },
                      ...itemsIE,
                      {
                        text: '',
                      },
                    ];
                  });

                  OARow.push({
                    text: puOA.itemsDonePercentage + '%',
                    alignment: 'center',
                    style: ['parrafo2'],
                    margin: [0, 5, 0, 0],
                  });

                  return [OARow, ...IERows];
                } else return [OARow];
              }).flat().filter((e: any) => !!e),
          ],
        },
        id: withDetails ? 'cronogram' : '',
        layout: {
          vLineWidth: () => 0.1,
          hLineWidth: () => 0.1,
        },
      });
    });
  }

  public buildCronogramForMonth(month: any, withDetails: boolean) {
    if (!month) {
      return {
        header: [],
        weekDaysColumns: [],
      };
    }
    return {
      header: [
        this.generalTableHeader({
          headerContent: {
            text: month.mes,
            colSpan: month.semanas.length,
            fillColor: "#F8F8F8",
            style: ['titulo6'],
            border: [true, true, true, true],
            // tslint:disable-next-line:max-line-length
            //borderColor: [generalTitleColor, null, withDetails ? generalTitleColor : lightFirstColumnColor, darkerLightFirstColumnColor],
          },
        }),
        ...month.semanas.map(() => ({})).slice(1),
      ],
      weekDaysColumns: month.semanas.map((week: any) => {
        return {
          text: week.iniDia + '-' + week.finDia,
          border: [true, true, true, true],
          alignment: 'center',
          style: ['titulo6'],
        };
      }),
    };
  }

  public buildItemsForMonth(month: any, puOA: any, ie: any = null): any[] {
    if (!month || !puOA) return [];
    return month.semanas.map((week: any) => {
      const item: any = ie
        ? week.planUnidadSemanaItemToList.find((e: any) => e.idPlanUnidadOA === puOA.id && e.ie_id === ie.id)
        : week.planUnidadSemanaItemToList.find((e: any) => e.idPlanUnidadOA === puOA.id && e.ie_id === null);
      if (!item) return {};

      // const numberOfLines: number = ie
      //   ? ie.name.length * 5.88 / 300
      //   : puOA.oa.name.length * 5.88 / 300;

      // tslint:disable-next-line:max-line-length
      // console.log("NUMBER OF LINES FOR " + (ie ? 'IE' : 'OA'), ie ? ie.name.length : puOA.oa.name.length, numberOfLines);

      if (item.tipo === 0 || item.tipo === 1) {
        const dot: any = this.blueDot(0);
        if (item.horas) {
          dot.alignment = 'right';
          return {
            margin: [3, 2, 0, 0],
            alignment: 'center',
            columns: [
              {
                text: item.horas + 'h',
                alignment: 'left',
                fontSize: 8.5,
              },
              dot,
            ],
          };
        } else {
          dot.alignment = 'center';
          dot.margin = [0, 2, 0, 0];
          return dot;
        }
      } else if (item.tipo === 2) {
        return {
          margin: [0, 2, 0, 0],
          text: 'EV',
          bold: true,
          alignment: 'center',
          fontSize: 10,
        };
      }
    });
  }

  public sectionTitle(unitPlan: any, append: any = '') {
    return [
      {
        text: [
          unitPlan.unit + ' - ' + unitPlan.name,
          append,
        ],
        alignment: 'left',
      },
      {
        text: unitPlan.hours + ' horas | ' + unitPlan.user.fullName,
        alignment: 'right',
      },
    ];
  }

  public generateColoredRows(headerTitles: string[], skipFirstColor: boolean = true): any[] {
    return headerTitles.map((headerTitle, index) => {
      const colorIndex = skipFirstColor ? index + 1 : index;
      return this.generalTableHeader({
        headerContent: {
          text: headerTitle,
          //...this.bottomBorderCell(this.lineColorByIndex(colorIndex)),
        },
      });
    });
  }

  public lineColorByIndex(columnIndex: number): string {
    return darkerLightColorArray[columnIndex];
  }

  public fillColorByIndex(rowIndex: number, node: any, columnIndex: number, skipFirstColor: boolean = true): string {
    const colorIndex = skipFirstColor ? columnIndex + 1 : columnIndex;
    return rowIndex === 0 ? '#F8F8F8': '';
    //return rowIndex === 0 ? lightColorArray[colorIndex] : '';
  }

  public buildObjectivesRows(puOAs: any[]): any[] {
    return [
      [
        {
          text: 'EJE',
          alignment: 'center',
          style: ['titulo6'],
          fontSize: 8,
        },
        {
          text: 'OA',
          alignment: 'center',
          style: ['titulo6'],
          fontSize: 8,
        },
        /*{
          text: 'HORAS',
          style: 'blueHeader',
          alignment: 'center',
          fontSize: 8,
        },*/
        {
          text: 'NRO INDICADORES',
          alignment: 'center',
          style: ['titulo6'],
          fontSize: 8,
        },
      ],
      ...puOAs.map((puOA) => {
        return [
          {
            text: puOA.oa.eje,
            alignment: 'center',
            style: ['parrafo2'],
            fontSize: 8,
            margin: [5, 0, 5, 0],
          },
          {
            text: puOA.oa.cod + (puOA.oa.categoria != this.dataToReport.categoryAbrev ? ' | ' + puOA.oa.categoria : '') + (puOA.oa.transversal ? ' *' : ''),
            alignment: 'center',
            style: ['parrafo2'],
            fontSize: 8,
            margin: [5, 0, 5, 0],
          },
          /*{
            text: puOA.hours,
            alignment: 'center',
            fontSize: 8,
            margin: [5, 0, 5, 0],
          },*/
          {
            text: puOA.oa.ies.length,
            alignment: 'center',
            style: ['parrafo2'],
            fontSize: 8,
            margin: [5, 0, 5, 0],
          },
        ];
      }),
      [
        {
          text: 'TOTALES',
          alignment: 'center',
          style: ['parrafo2'],
          fontSize: 8,
        },
        {
          text: puOAs.length,
          alignment: 'center',
          style: ['parrafo2'],
          fontSize: 8,
        },
        /*{
          text: puOAs.reduce(
            (totalHours: number, puOA) => totalHours + puOA.hours,
            0,
          ),
          alignment: 'center',
          fontSize: 8,
        },*/
        {
          text: puOAs.reduce(
            (totalIEs: number, puOA) => totalIEs + puOA.oa.ies.length,
            0,
          ),
          alignment: 'center',
          style: ['parrafo2'],
          fontSize: 8,
        },
      ],
    ];
  }

  public styleAndTransformImages(text, width){
    let renderized = this.ConvertStringToHTML(text);
    let images = renderized.getElementsByTagName('img');
    for ( let image of images ){
      if(image.src.startsWith("http", 0)){
        let a = document.createElement('a');
        a.href = image.src; 
        let link = document.createTextNode("Ver imagen");
        a.appendChild(link);
        let parent = image.parentElement; 
        if(parent){          
          parent.innerHTML = '';
          parent.appendChild(a)
        }
      }else{
        image.style.width= width+"px";
      }
    };
    return renderized.innerHTML;
  }

  public ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  };

}

export {
  PlanningReport,
};
